module.exports = __webpack_public_path__ + "img/servicecops.db5cc8c0.png";